import { Option } from '@interfaces/common/option';

export const RFB_QUALIFICATIONS: Option[] = [
  { label: '01 - Presidente', value: '01 - Presidente' },
  { label: '02 - Vice-Presidente', value: '02 - Vice-Presidente' },
  { label: '03 - Diretor-Presidente', value: '03 - Diretor-Presidente' },
  { label: '05 - Administrador', value: '05 - Administrador' },
  { label: '06 - Gerente', value: '06 - Gerente' },
  { label: '07 - Outros', value: '07 - Outros' },
  { label: '08 - Conselheiro de Administração', value: '08 - Conselheiro de Administração' },
  { label: '09 - Secretário', value: '09 - Secretário' },
  { label: '10 - Diretor', value: '10 - Diretor' },
  { label: '11 - Sócio-Gerente', value: '11 - Sócio-Gerente' },
  { label: '12 - Sócio', value: '12 - Sócio' },
  { label: '13 - Sócio Ostensivo', value: '13 - Sócio Ostensivo' },
  { label: '16 - Presidente do Conselho', value: '16 - Presidente do Conselho' },
  { label: '20 - Responsável', value: '20 - Responsável' },
  { label: '21 - Sócio Comanditado', value: '21 - Sócio Comanditado' },
  { label: '22 - Sócio', value: '22 - Sócio' },
  { label: '23 - Sócio Comanditário', value: '23 - Sócio Comanditário' },
  { label: '24 - Sócio Ostensivo', value: '24 - Sócio Ostensivo' },
  { label: '28 - Titular', value: '28 - Titular' },
  {
    label: '29 - Titular de Empresa Individual de Responsabilidade Limitada (EIRELI)',
    value: '29 - Titular de Empresa Individual de Responsabilidade Limitada (EIRELI)',
  },
  {
    label: '31 - Presidente do Conselho de Administração',
    value: '31 - Presidente do Conselho de Administração',
  },
  { label: '37 - Sócio-Diretor', value: '37 - Sócio-Diretor' },
  { label: '38 - Sócio-Industrial', value: '38 - Sócio-Industrial' },
  { label: '41 - Controlador', value: '41 - Controlador' },
  {
    label: '42 - Membro do Conselho de Administração',
    value: '42 - Membro do Conselho de Administração',
  },
  { label: '44 - Dirigente', value: '44 - Dirigente' },
  { label: '46 - Procurador', value: '46 - Procurador' },
  { label: '47 - Liquidante', value: '47 - Liquidante' },
  { label: '48 - Gestor', value: '48 - Gestor' },
  { label: '49 - Sócio-Administrador', value: '49 - Sócio-Administrador' },
  { label: '50 - Empresário', value: '50 - Empresário' },
  { label: '54 - Fundador', value: '54 - Fundador' },
  { label: '55 - Membro do Conselho Curador', value: '55 - Membro do Conselho Curador' },
  { label: '56 - Membro do Conselho Deliberativo', value: '56 - Membro do Conselho Deliberativo' },
  { label: '57 - Membro do Conselho Diretor', value: '57 - Membro do Conselho Diretor' },
  { label: '58 - Membro do Conselho Fiscal', value: '58 - Membro do Conselho Fiscal' },
  {
    label: '65 - Titular de Empresa Individual de Responsabilidade Limitada (EIRELI)',
    value: '65 - Titular de Empresa Individual de Responsabilidade Limitada (EIRELI)',
  },
  { label: '70 - Coordenador', value: '70 - Coordenador' },
  { label: '71 - Vice-Coordenador', value: '71 - Vice-Coordenador' },
  { label: '72 - Secretário-Executivo', value: '72 - Secretário-Executivo' },
  { label: '73 - Secretário-Geral', value: '73 - Secretário-Geral' },
  { label: '74 - Tesoureiro', value: '74 - Tesoureiro' },
];
